import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'fury-gestione-crawling-db',
    templateUrl: 'gestione-crawling-db.component.html',
    styleUrls: ['gestione-crawling-db.component.scss']
})

export class GestioneCrawlingDbComponent implements OnInit {
    constructor() { }

    ngOnInit() { }
}
